function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.122 20L4.60007 20C4.24002 20 4 19.7599 4 19.3999L4 6.1982C4 5.83815 4.24004 5.59813 4.60007 5.59813H9.40069L7.60046 7.99845H6.4003L6.4003 17.5997H17.2017V16.3995L19.602 13.9992V19.3999C19.602 19.76 19.362 20 19.122 20V20ZM14.9214 6.79827C11.3209 6.79827 8.44059 8.95855 8.80062 12.559C9.04066 14.8393 10.2408 15.1994 11.2009 15.9195C10.2408 13.8792 11.801 10.6388 15.5215 10.3987C15.6415 10.3987 15.8815 10.3987 16.0016 10.3987V13.9992L22.0023 8.59852L16.0016 3.19781V6.79829H14.9214L14.9214 6.79827Z",
  fill: "#00BB77"
});
const SvgSend = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send.9aeb75f3.svg";
export { ForwardRef as ReactComponent };